/**
* @Author: zachalam
* @Date:   2017-01-18T15:30:32-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-19T09:44:20-07:00
*/



import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import TextLink from '../common/TextLink';
import TextInput from '../common/TextInput';
import InputGroup from '../blocks/InputGroup';
import Button from '../blocks/Button';
import ButtonSet from '../blocks/ButtonSet';
import Container from '../blocks/Container';
import Headline from '../common/Headline';
import Panel from '../common/Panel';
import { css, StyleSheet } from 'aphrodite/no-important';
import { spacing } from '../../style';

const style = StyleSheet.create({

  message: {
    textAlign: 'center',
    ...spacing.MARGIN_TOP_LG
  }
})

class Login extends Component {

  state = {
    username: '',
    password: ''
  };

  setUsername = (e) => {
    this.setState({username: e.target.value});
  };

  setPassword = (e) => {
    this.setState({password: e.target.value});
  };

  logUserIn = (e) => {
    e.preventDefault();
    this.props.loginUser(this.state.username,this.state.password);
  };

  render() {
    return (
      <Container width='thin' padding='large' screenTop>
            <Headline spaceAfter>
              Log in to your account
            </Headline>
            <Panel padding='large'>
              <form onSubmit={this.logUserIn}>
                <InputGroup vertical inputLabel="Email or username">
                  <TextInput type="text" value={this.state.username} error={this.props.errors} onChange={this.setUsername} />
                </InputGroup>
                <InputGroup vertical inputLabel="Password" errors={this.props.errors}>
                  <TextInput error={this.props.errors} type="password" value={this.state.password} onChange={this.setPassword} />
                </InputGroup>
                <InputGroup vertical>
                  <Button variant="primary" fit focusable type="submit" name="commit">Log in now</Button>
                </InputGroup>
              </form>
              <div className={css(style.message)}>
                <TextLink to="/restoring">Forgot Your Password?</TextLink>
              </div>
            </Panel>
      <div className={css(style.message)}>
          Need an account? <TextLink to="/join">Create one here</TextLink>.
      </div>
    </Container>
    );
  }
}

Login.propTypes = {
  loginUser: PropTypes.func.isRequired
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/pages/Login.jsx